module.exports = __webpack_public_path__ + "static/media/frothluxe-1.2dffe7e9.jpg";